import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';

import { Box, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import CheckIcon from '@material-ui/icons/Check';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import {
  getLabelTipo,
  getValorFormatado,
} from '../../../Components/Dialogos/DialogoFornecedor/utils';
import { getListAllAPI } from '../../../services';
import {
  formatTelefone,
  formatCNPJ,
  formatCPF,
  formatCEP,
  formatIE,
  SECONDARY_COLOR,
  formatMoeda,
  POR_UNIDADE,
  POR_PESO_VARIAVEL_SEM_UNIDADE,
  formatPeso,
} from '../../../utils';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: SECONDARY_COLOR,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
    cursor: 'pointer',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
    cursor: 'pointer',
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const DEFAULT_ID = -1;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const SidebarInputs = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [id, setId] = useState(DEFAULT_ID);
  const [data, setData] = useState('-');
  const [numeroCompra, setNumeroCompra] = useState(0);
  const [fornecedor, setFornecedor] = useState({
    nome: '-',
    razaoSocial: '-',
    nomeFantasia: '-',
  });
  const [dataFaturamento, setDataFaturamento] = useState('-');
  const [valorTotal, setValorTotal] = useState(0);
  const [icmsFronteira, setIcmsFronteira] = useState('');
  const [loja, setLoja] = useState('');
  const [numeroNotaFiscal, setNumeroNotaFiscal] = useState('');
  const [itens, setItens] = useState([]);
  const [parcelas, setParcelas] = useState([]);

  const [carregando, setCarregando] = useState(false);
  const [value, setValue] = React.useState(0);

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function formatData(data) {
    return data ? moment(new Date(data)).format('DD/MM/YYYY') : '-';
  }

  function formatNumeroCompra(data) {
    return data || '-';
  }

  function formatFornecedor(data) {
    let nome = '-';
    let razaoSocial = '-';
    let nomeFantasia = '-';

    if (data) {
      nome = data.nome ? data.nome : '-';
      razaoSocial = data.razao_social ? data.razao_social : '-';
      nomeFantasia = data.nome_fantasia ? data.nome_fantasia : '-';
    }

    return {
      nome,
      razaoSocial,
      nomeFantasia,
    };
  }

  function formatDataFaturamento(data) {
    return data ? moment(new Date(data)).format('DD/MM/YYYY') : '-';
  }

  function formatValorTotal(data) {
    return formatMoeda(data);
  }

  function formatIcmsFronteira(data) {
    return data || '-';
  }

  function formatLoja(data) {
    return data || '-';
  }

  function formatNumeroNotaFiscal(data) {
    return data || '-';
  }

  function formatItens(data) {
    const vetor = [];
    for (let i = 0; i < data.length; i++) {
      const resource = data[i];
      const tipo = resource.produto.unidade.tipo;

      const qtde = tipo === POR_UNIDADE ? resource.unidades : resource.peso;

      const total = qtde * resource.preco_compra;

      vetor.push({
        id: resource.id,
        produto: resource.produto.nome,
        unidades:
          tipo === POR_PESO_VARIAVEL_SEM_UNIDADE ? '-' : resource.unidades,
        peso: tipo === POR_UNIDADE ? '-' : formatPeso(resource.peso),
        precoCompra: `${formatMoeda(resource.preco_compra)} ${
          tipo === POR_UNIDADE ? '/ Un.' : '/ Kg'
        }`,
        total: formatMoeda(total),
        cg: `${formatMoeda(resource.cg)} ${
          tipo === POR_UNIDADE ? '/ Un.' : '/ Kg'
        }`,
      });
    }
    return vetor;
  }

  function getDiasOriginalProvavel(despesa) {
    let value = '-';
    if (despesa.data_negociada) {
      const dataOriginal = new Date(
        moment(new Date(despesa.data_pagamento_original)).endOf('day').format(),
      );

      const dataProvavel = new Date(
        moment(new Date(despesa.data_negociada)).endOf('day').format(),
      );

      const delta = dataProvavel.getTime() - dataOriginal.getTime();

      value = parseInt(delta / (24 * 60 * 60 * 1000), 10);
    }
    return value;
  }

  function getDiasRealOriginal(despesa) {
    const dataReal = new Date(
      moment(new Date(despesa.data_pagamento)).endOf('day').format(),
    );

    const dataOriginal = new Date(
      moment(new Date(despesa.data_pagamento_original)).endOf('day').format(),
    );

    const delta = dataReal.getTime() - dataOriginal.getTime();

    const value = parseInt(delta / (24 * 60 * 60 * 1000), 10);

    return value;
  }

  function makeObjFatura(diaPagamento, mes, ano) {
    const dataPagamentoFatura = new Date();
    dataPagamentoFatura.setDate(diaPagamento);
    dataPagamentoFatura.setMonth(mes);
    dataPagamentoFatura.setFullYear(ano);
    const descricaoFatura = `${format(
      dataPagamentoFatura,
      "dd 'de' MMM 'de' yyyy",
      {
        locale: ptBR,
      },
    )}`;
    return descricaoFatura;
  }

  function formatParcelas(data) {
    const vetor = [];
    for (let i = 0; i < data.length; i++) {
      const parcela = data[i];
      const despesa = data[i].despesa;

      vetor.push({
        id: parcela.id,
        dataOriginal: moment(new Date(despesa.data_pagamento_original)).format(
          'DD/MM/YYYY',
        ),
        dataReal: moment(new Date(despesa.data_pagamento)).format('DD/MM/YYYY'),
        dataProvavel: despesa.data_negociada
          ? moment(new Date(despesa.data_negociada)).format('DD/MM/YYYY')
          : '-',
        conta: despesa.conta.nome,
        valor: formatMoeda(despesa.valor),
        status: despesa.status,
        valorOriginal: formatMoeda(despesa.valor_original),
        codigoBoleto: despesa.codigo_boleto ? despesa.codigo_boleto : '-',
        diferencaProvavelOriginal: getDiasOriginalProvavel(despesa),
        diferencaRealOriginal: getDiasRealOriginal(despesa),
        cartao: parcela.is_cartao ? despesa.fatura.cartao.nome : '-',
        fatura: despesa.fatura
          ? makeObjFatura(
              despesa.fatura.cartao.dia_pagamento,
              despesa.fatura.mes,
              despesa.fatura.ano,
            )
          : '-',
        categoriaProblema: despesa.problema ? despesa.problema.nome : '-',
        juros: formatMoeda(despesa.juros),
        multa: formatMoeda(despesa.multa),
        mora: formatMoeda(despesa.mora),
        encargos: formatMoeda(despesa.total_juros),
        desconto: formatMoeda(despesa.desconto),
      });
    }
    return vetor;
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI('compras', ['id', 'asc'], { id: [id] }, [
        'fornecedor.cidade.estado',
        'fornecedor.prazosFornecedores',
        'lotes.produto.unidade',
        'parcelas.despesa.conta',
        'parcelas.despesa.fatura.cartao',
        'parcelas.despesa.problema',
        'parcelas.despesa.agendador',
        'parcelas.despesa.categoria',
      ]);
      if (data.data.length > 0) {
        setId(data.data[0].id);
        //
        setData(formatData(data.data[0].data));
        setNumeroCompra(formatNumeroCompra(data.data[0].numero));
        setFornecedor(formatFornecedor(data.data[0].fornecedor));
        setDataFaturamento(
          formatDataFaturamento(data.data[0].data_faturamento),
        );
        setValorTotal(formatValorTotal(data.data[0].valor));
        setIcmsFronteira(formatIcmsFronteira(data.data[0].icms_fronteira));
        setLoja(formatLoja(data.data[0].loja));
        setNumeroNotaFiscal(
          formatNumeroNotaFiscal(data.data[0].numero_nota_fiscal),
        );
        setItens(formatItens(data.data[0].lotes));
        setParcelas(formatParcelas(data.data[0].parcelas));
        //
        setValue(0);
        setCarregando(false);
      } else {
        throw 'Esta compra não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog(-1);
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setOpen(true);
      setCarregando(true);
      getDataResource(id);
    },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      disableBackdropClick
      disableEscapeKeyDown
      fullScreen
    >
      <DialogTitle id="form-dialog-title">{`Compra nº ${numeroCompra}`}</DialogTitle>
      <DialogContent dividers>
        <div style={{ height: '100%' }}>
          <Box
            display={{ xs: 'block', sm: 'flex' }}
            flexDirection="column"
            marginBottom="30px"
            height="100%"
          >
            {carregando ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '300px',
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Box p="1em">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                >
                  <Tab label="Geral" {...a11yProps(0)} />
                  <Tab label="Fornecedor" {...a11yProps(1)} />
                  <Tab label="Itens" {...a11yProps(2)} />
                  <Tab label="Parcelas" {...a11yProps(3)} />
                </Tabs>
                <Box display="flex">
                  <Box flex={2} mr="1em">
                    <TabPanel value={value} index={0}>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Data:
                          </span>
                          {data}
                        </Box>
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Número Compra:
                          </span>
                          {numeroCompra}
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Data Faturamento:
                          </span>
                          {dataFaturamento}
                        </Box>
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Valor:
                          </span>
                          {valorTotal}
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            ICMS Fronteira:
                          </span>
                          {icmsFronteira}
                        </Box>
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Loja:
                          </span>
                          {loja}
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Número Nota Fiscal:
                          </span>
                          {numeroNotaFiscal}
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Responsável:
                          </span>
                          {fornecedor.nome}
                        </Box>
                        <Box flex={1}>
                          <span
                            style={{ fontWeight: 'bold', marginRight: '10px' }}
                          >
                            Razão Social:
                          </span>
                          {fornecedor.razaoSocial}
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        mt="20px"
                        fontSize={20}
                      >
                        <Box flex={1}>
                          <span
                            style={{
                              fontWeight: 'bold',
                              marginRight: '10px',
                            }}
                          >
                            Nome Fantasia:
                          </span>
                          {fornecedor.nomeFantasia}
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <Box mt="1em" />
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="customized table"
                        >
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>Produto</StyledTableCell>
                              <StyledTableCell>Qtde</StyledTableCell>
                              <StyledTableCell>Peso (Kg)</StyledTableCell>
                              <StyledTableCell>Preço de Compra</StyledTableCell>
                              <StyledTableCell>CG</StyledTableCell>
                              <StyledTableCell>Total</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {itens.map((row) => (
                              <StyledTableRow key={row.id}>
                                <StyledTableCell>{row.produto}</StyledTableCell>
                                <StyledTableCell>
                                  {row.unidades}
                                </StyledTableCell>
                                <StyledTableCell>{row.peso}</StyledTableCell>
                                <StyledTableCell>
                                  {row.precoCompra}
                                </StyledTableCell>
                                <StyledTableCell>{row.cg}</StyledTableCell>
                                <StyledTableCell>{row.total}</StyledTableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                      <Box mt="1em" />
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="customized table"
                        >
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>Data Original</StyledTableCell>
                              <StyledTableCell>Data Real</StyledTableCell>
                              <StyledTableCell>Conta</StyledTableCell>
                              <StyledTableCell>Cartão</StyledTableCell>
                              <StyledTableCell>Fatura</StyledTableCell>
                              <StyledTableCell>Valor Original</StyledTableCell>
                              <StyledTableCell>Valor</StyledTableCell>
                              <StyledTableCell>Status</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {parcelas.map((row) => (
                              <StyledTableRow key={row.id}>
                                <StyledTableCell>
                                  {row.dataOriginal}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {row.dataReal}
                                </StyledTableCell>
                                <StyledTableCell>{row.conta}</StyledTableCell>
                                <StyledTableCell>{row.cartao}</StyledTableCell>
                                <StyledTableCell>{row.fatura}</StyledTableCell>
                                <StyledTableCell>
                                  {row.valorOriginal}
                                </StyledTableCell>
                                <StyledTableCell>{row.valor}</StyledTableCell>
                                <StyledTableCell>
                                  {row.status ? (
                                    <Avatar className={classes.confirmado}>
                                      <CheckIcon style={{ fontSize: 15 }} />
                                    </Avatar>
                                  ) : (
                                    <Avatar className={classes.pendente}>
                                      <PriorityHighIcon
                                        style={{ fontSize: 15 }}
                                      />
                                    </Avatar>
                                  )}
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.wrapper}>
          <Button
            color="primary"
            onClick={() => {
              handleCloseDialog();
            }}
            disabled={carregando}
            classes={{
              root: classes.btnAtions,
              disabled: classes.btnAtionsDisabled,
            }}
          >
            Fechar
          </Button>
          {carregando && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
});

export default SidebarInputs;
